export function Section({ children, className = "", id }) {
  return (
    <section id={id} className={`max-w-7xl mx-auto px-5 lg:px-8 ${className}`}>
      {children}
    </section>
  );
}

export function Eyebrow({ children }) {
  return <div className="eyebrow mb-4">{children}</div>;
}

export function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <div className="relative overflow-hidden border-b border-white/10">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-[#0A0A0C]/80 to-[#0A0A0C]" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-24 lg:py-32">
        {eyebrow && <div className="eyebrow mb-4 fade-up">{eyebrow}</div>}
        <h1 className="font-display font-black uppercase tracking-tight leading-[1.05] text-4xl sm:text-6xl lg:text-7xl fade-up" style={{ animationDelay: "0.05s" }}>
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-300 leading-relaxed fade-up" style={{ animationDelay: "0.15s" }}>
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}

export function EmptyState({ label = "À COMPLÉTER", note }) {
  return (
    <div className="card-dark p-10 text-center">
      <div className="inline-block font-mono text-xs uppercase tracking-widest px-3 py-1.5 rounded-full bg-amber-400/10 text-amber-300 border border-amber-400/20">
        {label}
      </div>
      {note && <p className="text-slate-500 mt-4 text-sm">{note}</p>}
    </div>
  );
}

export function SpecialRequest() {
  const wa = "https://wa.me/33782798521?text=" + encodeURIComponent("Bonjour AL Music Records, j'ai une demande particulière :");
  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14" data-testid="special-request-section">
      <div className="rounded-2xl border border-emerald-500/25 bg-emerald-500/[0.04] p-8 sm:p-10 text-center">
        <div className="eyebrow mb-3" style={{ color: "#34d399" }}>Une demande particulière ?</div>
        <h2 className="font-display font-extrabold text-2xl sm:text-3xl">Prestation sur mesure, événement ou partenariat ?</h2>
        <p className="text-slate-400 mt-3 max-w-2xl mx-auto">
          Pour une demande personnalisée, un devis (par ex. un mixage de plus de 8 pistes), un événement, un partenariat
          ou une question concernant une réservation, écrivez-nous directement sur WhatsApp.
        </p>
        <a
          href={wa}
          target="_blank"
          rel="noreferrer"
          data-testid="special-request-whatsapp"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full font-display font-bold bg-emerald-500 text-black hover:bg-emerald-400 transition-colors"
        >
          Nous écrire sur WhatsApp — 07 82 79 85 21
        </a>
      </div>
    </section>
  );
}

export function SoundBars() {
  return (
    <div className="flex items-end gap-1 h-6">
      {[0, 1, 2, 3, 4].map((i) => (
        <span key={i} className="soundbar" style={{ animationDelay: `${i * 0.12}s`, height: "40%" }} />
      ))}
    </div>
  );
}
